import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import { useAccountsStore } from "../_store/useAccounts.store";
import { AccountsMeta, AccountsQueryData } from "../_types/accounts.types";

const FALLBACK_META: AccountsMeta = {
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

export const useAccountsQuery = () => {
  const role = useAccountsStore((state) => state.role);
  const subscription = useAccountsStore((state) => state.subscription);
  const period = useAccountsStore((state) => state.period);
  const search = useAccountsStore((state) => state.search);
  const page = useAccountsStore((state) => state.page);
  const limit = useAccountsStore((state) => state.limit);

  const [searchDebounced, setSearchDebounced] = useState(search);

  useEffect(() => {
    const t = setTimeout(() => setSearchDebounced(search.trim()), 300);
    return () => clearTimeout(t);
  }, [search]);

  return useQuery({
    queryKey: ["accounts", role, subscription, period, searchDebounced, page, limit],
    queryFn: async (): Promise<AccountsQueryData> => {
      const response = await axiosInstance.get<
        ApiResponse<AccountsQueryData["items"], AccountsMeta>
      >("/v2/accounts/customers", {
        params: {
          role,
          subscription,
          period,
          ...(searchDebounced.length > 0 ? { q: searchDebounced } : {}),
          page,
          limit,
        },
      });

      return {
        items: response.data.data ?? [],
        meta: response.data.meta ?? {
          ...FALLBACK_META,
          page,
          limit,
        },
      };
    },
    placeholderData: (previousData) => previousData,
  });
};
